import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import React, { useEffect } from 'react';
import { theme } from '../themes/theme.js';
import { PeekDivider } from './PeekDivider.js';
import { PeekStack } from './PeekStack.js';
import { PeekTextField } from './PeekTextField.js';
import { PeekTypography } from './PeekTypography.js';
import { useTheme } from '@mui/material/styles';

const DateFieldItem = ({ onChange, value, label }) => {
    const theme = useTheme();
    return (React.createElement(LocalizationProvider, { dateAdapter: AdapterDayjs },
        React.createElement(DatePicker, { label: label, value: value, renderInput: (params) => (React.createElement(PeekTextField, Object.assign({ variant: "standard" }, params, { sx: {
                    ".MuiInput-root": {
                        border: "none !important",
                        backgroundColor: "transparent !important",
                        mt: "0 !important",
                    },
                    button: {
                        color: "transparent !important",
                        backgroundColor: "transparent !important",
                        borderRadius: "0 !important",
                        width: "80px !important",
                        position: "absolute",
                        left: 0,
                        top: 0,
                    },
                    ":hover": {
                        color: `${theme.palette.secondary.main} !important`,
                    },
                } }))), 
            //@ts-ignore
            onChange: onChange, InputProps: {
                sx: {
                    width: 75,
                },
                disableUnderline: true,
            }, inputFormat: "MMM DD" })));
};
/** Peek Date Input */
const PeekDateRangeInput = ({ field, form, label, showTotalDays = true }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const { name } = field;
    const error = form.touched[name] && Boolean(form.errors[name]);
    useEffect(() => {
        var _a, _b;
        // Invert dates if start date is after end date
        if (((_a = field.value) === null || _a === void 0 ? void 0 : _a.startDate) && ((_b = field.value) === null || _b === void 0 ? void 0 : _b.endDate)) {
            if (field.value.startDate.isAfter(field.value.endDate)) {
                const startDateTemp = field.value.startDate;
                const endDateTemp = field.value.endDate;
                // @ts-ignore
                form.setFieldValue("dateRange.startDate", endDateTemp);
                // @ts-ignore
                form.setFieldValue("dateRange.endDate", startDateTemp);
            }
        }
    }, [form.values]);
    return (React.createElement(PeekStack, null,
        React.createElement(PeekTypography, { variant: "h4" }, label),
        React.createElement(PeekStack, { direction: "row", alignItems: "center", sx: {
                border: `1px solid ${error ? "red" : theme.palette.grey[200]} !important`,
                borderRadius: "12px !important",
                pr: 1,
                mt: 1,
                height: theme.spacing(3.8),
            } },
            React.createElement(DateFieldItem, { value: (_a = field.value) === null || _a === void 0 ? void 0 : _a.startDate, 
                //@ts-ignore
                onChange: (date) => form.setFieldValue("dateRange.startDate", date) }),
            React.createElement(PeekTypography, { variant: "h3" }, "-"),
            React.createElement(DateFieldItem, { value: (_b = field.value) === null || _b === void 0 ? void 0 : _b.endDate, 
                //@ts-ignore
                onChange: (date) => form.setFieldValue("dateRange.endDate", date) }),
            showTotalDays && (React.createElement(PeekStack, { direction: "row", alignItems: "center", spacing: 1, justifyContent: "space-between", width: theme.spacing(6.2) },
                React.createElement(PeekDivider, { orientation: "vertical", sx: { borderColor: theme.palette.grey[200], height: "22px", mx: 0.1 } }),
                React.createElement(PeekTypography, { variant: "h4", whiteSpace: "nowrap" }, (_f = Math.abs(((_d = (_c = field.value) === null || _c === void 0 ? void 0 : _c.startDate) === null || _d === void 0 ? void 0 : _d.diff((_e = field.value) === null || _e === void 0 ? void 0 : _e.endDate, "days")) - 1)) === null || _f === void 0 ? void 0 :
                    _f.toString(),
                    " ",
                    Math.abs((_h = (_g = field.value) === null || _g === void 0 ? void 0 : _g.startDate) === null || _h === void 0 ? void 0 : _h.diff((_j = field.value) === null || _j === void 0 ? void 0 : _j.endDate, "days")) > 1 ? "days" : "day"))))));
};

export { DateFieldItem, PeekDateRangeInput, PeekDateRangeInput as default };
